import { Controller } from 'react-hook-form';
import { ErrorText, TextInput } from '@buoyhealth/common.buoy-input';
import type { Control } from 'react-hook-form';
import FormLabel from './FormLabel';

export interface ITextFormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  control: Control<any, any>;
  name: string;
  label?: string;
  errorMessage?: string;
  required?: boolean;
  /** add a tooltip next to the form label */
  tooltipText?: string;
  helperText?: string;
  validationPattern?: RegExp;
}

const TextFormInput = ({
  control,
  name,
  label,
  autoComplete,
  errorMessage,
  required = false,
  tooltipText,
  helperText,
  validationPattern,
  ...rest
}: ITextFormInputProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        const { ref: inputRef, ...fieldProps } = field;
        return (
          <div>
            {label && <FormLabel name={name} label={label} tooltipText={tooltipText} />}
            <TextInput
              {...fieldProps}
              autoComplete={autoComplete}
              InputLabelProps={{
                htmlFor: `${name}-input`,
                className: 'bp-text-base',
              }}
              id={`${name}-input`}
              inputProps={{
                'data-testid': `${name}-input`,
                className: '!bp-placeholder-gray-70',
                ...rest,
              }}
              InputProps={{
                sx: { backgroundColor: 'white' },
              }}
              fullWidth
              error={!!fieldState.error}
              inputRef={inputRef}
              helperText={helperText}
            />
            <ErrorText
              show={!!fieldState.error}
              message={errorMessage || 'This field is required'}
            />
          </div>
        );
      }}
      rules={{
        required,
        validate: (val) => (required ? !!val?.trim() : true),
        pattern: validationPattern,
      }}
    />
  );
};

export default TextFormInput;
